<pagination-template #p="paginationApi" [id]="$any(config).id" (pageChange)="onPageChange($event)">
  <ul class="pagination">
    <li>
      <button
        [disabled]="p.isFirstPage()"
        [style.background-color]="colorCode()"
        class="btn btn-primary"
        (click)="p.previous()">
        {{ "GAST-PORTAL-NG.GENERIC-PAGINATION-COMPONENT.BACK" | translate }}
      </button>
    </li>
    @for (page of p.pages; track $index) {
      <li [class.current-page]="p.getCurrent() === page.value">
        @if (p.getCurrent() !== page.value) {
          <button [style.background-color]="colorCode()" class="btn btn-primary" (click)="p.setCurrent(page.value)">
            {{ page.label }}
          </button>
        }
        @if (p.getCurrent() === page.value) {
          <button [style.background-color]="colorCode()" class="btn btn-primary">{{ page.label }}</button>
        }
      </li>
    }
    <li>
      <button
        [disabled]="p.isLastPage()"
        [style.background-color]="colorCode()"
        class="btn btn-primary"
        (click)="p.next()">
        {{ "GAST-PORTAL-NG.GENERIC-PAGINATION-COMPONENT.NEXT" | translate }}
      </button>
    </li>
  </ul>
</pagination-template>
